import React from 'react';
import keyRingPositionGenerator from '../key_inserter.js'

const generateKeyRings = ({ width, height, center_x, center_y, angle, onKeyPositionGenerated }) => {
	const angle_start_0 = 2.1080
	const angle_step_0  = 0.04360
	const radius_0      = 0.30020 * width
	const center_x_0    = center_x
	const center_y_0    = center_y
	const width_0       = 0.0485 * width
	const height_0      = 0.006 * height

	const key_rings = [
		{
			angle_start: angle_start_0,
			angle_step: angle_step_0,
			radius: radius_0,
			center: {
				x: center_x_0,
				y: center_y_0
			},
			width: width_0,
			height: height_0
		},
		{
			angle_start: 0.932 * angle_start_0,
			angle_step: 1.0011 * angle_step_0,
			radius: 0.761 * radius_0,
			center: {
				x: 0.998 * center_x_0,
				y: 0.9984 * center_y_0
			},
			width: 0.732 * width_0,
			height: 0.6667 * height_0
		},
		{
			angle_start: 0.869 * angle_start_0,    // ≈ 1.831
			angle_step: 1.0002 * angle_step_0,     // ≈ 0.04361
			radius: 0.579 * radius_0,              // 0.1750 / 0.3022
			center: {
				x: center_x_0,
				y: 0.9984 * center_y_0             // 0.4935 / 0.4943
			},
			width: 0.5258 * width_0,               // 0.0255 / 0.0485
			height: 0.5 * height_0                 // 0.003 / 0.006
		},
		{
			angle_start: 0.799 * angle_start_0,    // ≈ 1.685
			angle_step: 1.0002 * angle_step_0,
			radius: 0.4386 * radius_0,             // 0.1325 / 0.3022
			center: {
				x: center_x_0,
				y: 0.9984 * center_y_0
			},
			width: 0.4227 * width_0,               // 0.0205 / 0.0485
			height: 0.5 * height_0
		},
		{
			angle_start: 0.735 * angle_start_0,    // ≈ 1.550
			angle_step: 1.0002 * angle_step_0,
			radius: 0.3327 * radius_0,             // 0.1005 / 0.3022
			center: {
				x: center_x_0,
				y: 0.9984 * center_y_0
			},
			width: 0.3196 * width_0,               // 0.0155 / 0.0485
			height: 0.5 * height_0
		}
	].forEach(({width, height, ...key_ring}, key_ring_index) => {
		keyRingPositionGenerator({
			...key_ring,
			onKeyPositionGenerated: key_position => {
				onKeyPositionGenerated({ width, height, ...key_position }, key_ring_index)
			}
		})
	})
}

export default generateKeyRings